import { render } from "./GenEdit.vue?vue&type=template&id=031156aa"
import script from "./GenEdit.vue?vue&type=script&lang=js"
export * from "./GenEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__